<pbc-sorter [config]="BewertungsAnlasssSorterConfig" [sorter]="bewertungsAnlasss.sorter$ | async" (sorterChange)="bewertungsAnlasss.sorter$.next($event)"></pbc-sorter>
